var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0C3.61875 0 3 0.61875 3 1.375V20.625C3 21.3813 3.61875 22 4.375 22H18.125C18.8813 22 19.5 21.3813 19.5 20.625V5.5L14 0H4.375Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 5.5H19.5L14 0V4.125C14 4.88125 14.6187 5.5 15.375 5.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.625L15.375 5.5H19.5V9.625Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 17.875C16.75 18.2531 16.4406 18.5625 16.0625 18.5625H0.9375C0.559375 18.5625 0.25 18.2531 0.25 17.875V11C0.25 10.6219 0.559375 10.3125 0.9375 10.3125H16.0625C16.4406 10.3125 16.75 10.6219 16.75 11V17.875Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57251 16.4999C4.22601 16.4999 4.08851 16.1651 4.28651 15.9286L6.24382 13.3284H4.62132C4.14351 13.3284 4.18201 12.6533 4.62132 12.6533H6.83713C7.25445 12.6533 7.37545 13.0479 7.07913 13.3676L5.20432 15.8021H6.99113C7.43113 15.8021 7.48613 16.5006 6.94782 16.5006H4.57251V16.4999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98828 13.0261C7.98828 12.5751 8.71428 12.5586 8.71428 13.0261V16.1645C8.71428 16.6204 7.98828 16.632 7.98828 16.1645V13.0261Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 13.026C9.6875 12.8445 9.8305 12.6465 10.0615 12.6465H11.3313C12.0463 12.6465 12.6898 13.125 12.6898 14.0421C12.6898 14.9111 12.0463 15.3951 11.3313 15.3951H10.4135V16.1211C10.4135 16.3631 10.2595 16.4999 10.0615 16.4999C9.88 16.4999 9.6875 16.3631 9.6875 16.1211V13.026ZM10.4128 13.3388V14.7083H11.3306C11.6991 14.7083 11.9906 14.3831 11.9906 14.0421C11.9906 13.6578 11.6991 13.3388 11.3306 13.3388H10.4128Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 18.5625H3V19.25H16.0625C16.4406 19.25 16.75 18.9406 16.75 18.5625V17.875C16.75 18.2531 16.4406 18.5625 16.0625 18.5625Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.a65eab5af6c565f7b6c7b5d5b758f728.svg";
export { ForwardRef as ReactComponent };